import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
    Header,
    Footer,
} from '@usb-onboarding/product-recommender-components';
import { USBIconWarning } from '@usb-shield/react-icons';
import defaultLang from '../../language';
import './RoleError.scss';

function RoleError() {
    const AEMContent = useSelector(
        (state) => state.AEMContentReducer.AEMContent,
    );

    return (
        <>
            <Header title={defaultLang.header.fullName} />
            <Helmet>
                <title>Business Product Selector | U.S. Bank</title>
            </Helmet>
            <div className="app-error-container">
                <div className="app-error">
                    <div className="warning-icon-container">
                        <USBIconWarning
                            colorVariant="error"
                            size="60"
                        />
                    </div>
                    <h1>
                        {defaultLang.errorContent.roleErrorHeading}
                    </h1>
                    <p>
                        {
                            defaultLang.errorContent
                                .roleErrorDescription
                        }
                    </p>
                </div>
            </div>
            <Footer
                header={defaultLang.footer.connectionTitle}
                content={defaultLang.footer.footerDisclosure}
                privacyLabel={AEMContent.footer.privacyLabel}
                privacyUrl={AEMContent.footer.privacyUrl}
                fdic={defaultLang.footer.connectionContent}
                cobrowseLabel={AEMContent.footer.cobrowseLabel}
                cobrowseUrl={AEMContent.footer.cobrowseUrl}
            />
        </>
    );
}

export default RoleError;
